// User action types
export const SET_USER_INFO = 'SET_USER_INFO';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';

// User state interface
export interface UserInfo {
  username: string;
  email: string;
  sub?: string;
  preferredUsername?: string;
  cognitoUsername?: string;
  idToken?: string;
  accessToken?: string;
  refreshToken?: string;
  tokenExpiration?: number; // Unix timestamp in seconds
  authTime?: number; // Unix timestamp in seconds
  familyName?: string;
  givenName?: string;
  provider?: string;
}

export interface UserState {
  userInfo: UserInfo | null;
  isAuthenticated: boolean;
  // Direct access fields (not nested in userInfo)
  userName: string;
  email: string;
  familyName: string;
  givenName: string;
  token: string;
  provider: string;
  expiration: number;
}

// Action interfaces
export interface SetUserInfoAction {
  type: typeof SET_USER_INFO;
  payload: UserInfo;
}

export interface ClearUserInfoAction {
  type: typeof CLEAR_USER_INFO;
}

export type UserActionTypes = SetUserInfoAction | ClearUserInfoAction;
